import { useTranslation } from 'next-i18next';
import { capitalize } from 'lodash';

interface IBedTime {
  time: string;
}
const BedTime = ({ time }: IBedTime) => {
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  return (
    <div className={time}>
      <picture>
        <source
          data-srcset="/images/homePage/fill.gif"
          media="(max-width: 801px)"
          srcSet="/images/homePage/fill.gif"
        />
        <img
          className="lazy entered loaded"
          alt={tCategory('bed')}
          src={`/images/homePage/bedSection/CYM-Room-${capitalize(time)}.webp`}
          width={1920}
          height={850}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
      </picture>
    </div>
  );
};
export default BedTime;
